"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTypedModel = exports.isClass = void 0;
function isClass(obj) {
    const isCtorClass = obj.constructor && obj.constructor.toString().substring(0, 5) === 'class';
    if (obj.prototype === undefined) {
        return isCtorClass;
    }
    const isPrototypeCtorClass = obj.prototype.constructor &&
        obj.prototype.constructor.toString &&
        obj.prototype.constructor.toString().substring(0, 5) === 'class';
    return isCtorClass || isPrototypeCtorClass;
}
exports.isClass = isClass;
const convertOnParam = (info, paramName) => {
    if (!info[paramName])
        return;
    const type = info[paramName].type;
    if (!type)
        return;
    if (typeof type !== 'function')
        return;
    if (!isClass(type))
        return;
    if (!type.getModel || !type.__schemaId)
        return;
    info[paramName].type = type.getModel().getCleanSchema();
};
const convertTypedModel = (info) => {
    convertOnParam(info, 'schema');
    convertOnParam(info, 'currentSchema');
};
exports.convertTypedModel = convertTypedModel;
